import './HiveTooltipItem.css';
export var bodyContainer = '_ugkbz30-2-0-1';
export var valueContent = '_ugkbz31-2-0-1';